import { Injectable } from "@angular/core";

@Injectable()
export class StyleService {
  borderWidth = [
    {
      name: "Small",
      value: 1
    },
    {
      name: "Medium",
      value: 2
    },
    {
      name: "Big",
      value: 3
    }
  ];
  borderRadius = [
    {
      name: "Big",
      value: 10
    },
    {
      name: "Medium",
      value: 5
    },
    {
      name: "Small",
      value: 3
    }
  ];
  fontSize = [
    {
      value: 10
    },
    {
      value: 11
    },
    {
      value: 12
    },
    {
      value: 13
    },
    {
      value: 14
    },
    {
      value: 15
    },
    {
      value: 16
    },
    {
      value: 17
    },
    {
      value: 18
    },
    {
      value: 19
    },
    {
      value: 20
    }
  ];
  fontWeight = [
    {
      value: 100
    },
    {
      value: 200
    },
    {
      value: 300
    },
    {
      value: 400
    },
    {
      value: 500
    },
    {
      value: 600
    },
    {
      value: 700
    },
    {
      value: 800
    },
    {
      value: 900
    }
  ];
  sizeOpts = [
    {
      name: "Full size",
      value: 100
    },
    {
      name: "1/2 size",
      value: 48
    },
    {
      name: "1/3 size",
      value: 31.3
    }
  ];
  shadowOpts = [
    {
      name: "top",
      value: "0px -2px 5px"
    },
    {
      name: "top blurred",
      value: "0px -2px 10px"
    },
    {
      name: "right",
      value: "2px 0px 5px"
    },
    {
      name: "right blurred",
      value: "2px 0px 10px"
    },
    {
      name: "left",
      value: "-2px 0px 5px"
    },
    {
      name: "left blurred",
      value: "-2px 0px 10px"
    },
    {
      name: "bottom",
      value: "0px 2px 5px"
    },
    {
      name: "bottom blurred",
      value: "0px 2px 10px"
    },
    {
      name: "none",
      value: ""
    }
  ];
  logoPositionOpts = [
    {
      name: "left",
      value: "flex-start"
    },
    {
      name: "center",
      value: "center"
    },
    {
      name: "right",
      value: "flex-end"
    }
  ];
  fontOpts = [
    {
      name: "Times New Roman"
    },
    {
      name: "Helvetica"
    },
    {
      name: "Tahoma"
    }
    // {
    //   name: 'Samsung One',
    // },
    // {
    //   name: 'Samsung Sharp Sans',
    // },
    // {
    //   name: 'InterstateWGL',
    // },
    // {
    //   name: 'Bliss2',
    // },
  ];
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/style.service.ts